import { useIntl } from 'react-intl-next';

import { renderDateString, useDateLocale } from '../../common/utils/utils';
import type { DatePickerValue } from '../../types';

import messages from './messages';

export type UseDateLabelOptions = {
	value: DatePickerValue | undefined;
	placeholder?: string;
	withTimeScale?: boolean;
	showPlaceholderWithSubtleText?: boolean;
};

/**
 * Shared hook for computing the date label and text color for DateRange components.
 * Used by both DateRange and ViewOnlyDateRange to maintain consistency.
 */
export const useDateLabel = ({
	value: date,
	placeholder,
	withTimeScale,
}: UseDateLabelOptions): string => {
	const { formatMessage } = useIntl();
	const locale = useDateLocale();

	const noDateSelectedMessage = placeholder ? placeholder : formatMessage(messages.noDateSet);

	const dateLabel = date
		? renderDateString(locale, date, placeholder, withTimeScale) ?? noDateSelectedMessage
		: noDateSelectedMessage;

	return dateLabel;
};
